/// <reference path="../../Common/Helpers/GridEditorDialog.ts" />

namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderProductBillingItemsTaxEditDialog extends Common.GridEditorDialog<OrderProductBillingItemsTaxRow> {
        protected getFormKey() { return OrderProductBillingItemsTaxForm.formKey; }
        protected getLocalTextPrefix() { return OrderProductBillingItemsTaxRow.localTextPrefix; }

        protected form: OrderProductBillingItemsTaxForm;
        public stateIds: number;

        public OrderStatus: number;
        //constructor() {
        //    super();
        //    this.form = new OrderProductsForm(this.idPrefix);
        //    this.form.Quantity  .changeSelect2(e => {
        //        var productId = this.form.ProductId.value.toString();
        //        var ProductSpecificationId = this.form.ProductSpecificationId.value;
        //        var stateIds = this.stateIds;
        //        debugger;
        //        if (Q.isEmptyOrNull(ProductSpecificationId.toString())) {
        //            if (Q.isEmptyOrNull(productId) == false) {
        //                Products.ProductsService.Retrieve({
        //                    EntityId: productId
        //                }, response => {
        //                    if (response.Entity.IsActive == false) {
        //                        Q.notifyError("Product is Inactive"); return;
        //                    }
        //                    else {
        //                        // this.setProductDetails(response.Entity);
        //                        try {

        //                            OrderProductsService.GetGSTRate({
        //                                ProductId: productId,
        //                                stateId: this.stateIds
        //                            }, response => {
        //                                // this.seEntityDetails(response.TotalItemRate);
        //                                if (this.form.Quantity.value == null) {
        //                                    this.form.Quantity.value = 1;
        //                                }
        //                                this.form.Cost.value = response.cost;
        //                                this.form.Amount.value = this.form.Quantity.value * this.form.Cost.value;

        //                            });

        //                        } catch (e) {

        //                        }

        //                    }
        //                });

        //            }
        //            else {
        //                Q.alert("Please Select Product First");
        //                return;
        //            }
        //        }
        //        else {

        //            Products.ProductSpecificationsService.Retrieve2({
        //                EntityId: ProductSpecificationId
        //            }, response => {
        //                this.setProductSpecificationDetails(response.Entity);
        //            })


        //        }


        //    });

        //    this.form.ProductId.changeSelect2(e => {
        //        var ProductId = this.form.ProductId.value;
        //        if (Q.isEmptyOrNull(ProductId.toString())) {
        //            //this.setProductDetails({});
        //            return;
        //        }
        //        else {
        //            //var ModuleName = Q.first(Vendor_Bill_ProductRow.getLookup().items, x => x.ProductId == Number(ProductId)).ProductProductName;
        //            //this.form.ProductId.value = ModuleName.toString();
        //            try {

        //                var ProductName = Q.first(Products.ProductsRow.getLookup().items, x => x.ProductId == Number(ProductId)).ProductName;
        //                this.form.ProductProductName.value = ProductName.toString();
        //            } catch (e) {

        //            }
        //            try {
        //                Products.ProductsService.Retrieve({
        //                    EntityId: ProductId
        //                }, response => {
        //                    this.setProductDetails(response.Entity);
        //                })

        //                    try {
        //                        OrderProductsService.GetGSTRate({
        //                            ProductId: ProductId,
        //                            stateId: this.stateIds
        //                        }, response => {
        //                              //  this.seEntityDetails(response.TotalItemRate, response.TotalItemRate);
        //                            if (this.form.Quantity.value == null) {
        //                                this.form.Quantity.value = 1;
        //                                }
        //                                this.form.Cost.value = response.cost;
        //                            this.form.Amount.value = this.form.Quantity.value * this.form.Cost.value;

        //                        });


        //                    } catch (e) {

        //                    }
        //                //});
        //            } catch (e) {

        //            }
        //        }
        //    });

        //    this.form.ProductSpecificationId.changeSelect2(e => {
        //        var ProductSpecificationId = this.form.ProductSpecificationId.value;
        //        if (Q.isEmptyOrNull(ProductSpecificationId.toString())) {
                    
        //            return;
        //        }
        //        else {
                   
        //            try {
        //                Products.ProductSpecificationsService.Retrieve2({
        //                    EntityId: ProductSpecificationId
        //                }, response => {
        //                    this.setProductSpecificationDetails(response.Entity);
        //                })
                       
        //            } catch (e) {

        //            }
        //        }
        //    });



        //}

        //private seEntityDetails(totalTaxRate: number) {
            
        //    if (this.form.Quantity.value == null) {
        //        this.form.Quantity.value = 1;
        //    }
        //  //  this.form.TaxAmount.value = this.form.Amount.value * totalTaxRate / 100;

        //    //  this.form.Amount.value = this.form.Quantity.value * this.form.Cost.value;

        //}
        //private setProductDetails(details: Products.ProductsRow) {
        //    if (this.form.Quantity.value == null) {
        //        this.form.Quantity.value = 1;
        //    }
        //    /*this.form.Cost.value = details.Cost;*/
        //    if (details.EOpens != null)
        //        this.form.EOpens.value = details.EOpens.toString();
        //    if (details.EWatchTime != null)
        //        this.form.EWatchTime.value = details.EWatchTime.toString();
        //    if (details.EValidityType != null)
        //        this.form.EValidityType.value = details.EValidityType.toString();
        //    if (details.EValidity != null)
        //        this.form.EValidity.value = details.EValidity.toString();
        //    if (details.ValidTill != null)
        //        this.form.ValidTill.value = details.ValidTill;
        //    if (details.HasBooks != null)
        //        this.form.HasBooks.value = details.HasBooks;
        //    if (details.HasPenDrive != null)
        //        this.form.HasPendrive.value = details.HasPenDrive;
        //    if (details.HasCourier != null)
        //        this.form.HasCourier.value = details.HasCourier;
        //    if (details.IsLive != null)
        //        this.form.IsLive.value = details.IsLive;
        //    /*this.form.Amount.value = this.form.Quantity.value * this.form.Cost.value;*/

        //}
        //private setProductSpecificationDetails(details: Products.ProductSpecificationsRow) {
        //    debugger;
        //    if (details.Eopens != null)
        //        this.form.EOpens.value = details.Eopens.toString();
        //    if (details.EWatchtime != null)
        //        this.form.EWatchTime.value = details.EWatchtime.toString();
        //    if (details.EValidityType != null)
        //        this.form.EValidityType.value = details.EValidityType.toString();
        //    if (details.EValidity != null)
        //        this.form.EValidity.value = details.EValidity.toString();
        //    if (details.ValidTill != null)
        //        this.form.ValidTill.value = details.ValidTill;
        //    if (details.HasBooks != null)
        //        this.form.HasBooks.value = details.HasBooks;
        //    if (details.HasPendrive != null)
        //        this.form.HasPendrive.value = details.HasPendrive;         
        //    if (details.IsLive != null)
        //        this.form.IsLive.value = details.IsLive;
        //    if (details.AllowedDevices != null)
        //        this.form.AllowedDevices.value = details.AllowedDevices;
        //        //this.form.Cost.value = details.ProductCost ;
        //        //this.form.Amount.value = this.form.Cost.value * this.form.Quantity.value;  

        //}
        //private setTaxRateDetails(detailsTaxRate: Masters.TaxRatesRow) {

        //    debugger;
        //    this.form.TaxAmount.value = this.form.Amount.value * detailsTaxRate.Rate / 100;

        //}


        loadEntity(entity: OrderProductBillingItemsTaxRow) {
            super.loadEntity(entity);

        }

    }
}